import { redirect, RouteObject } from 'react-router';
import PermissionGuard from '../gate/PermissionGuard';
import { PERMISSIONS } from '@/shared/constants';

export const benefitsRoutes: RouteObject[] = [
	{
		path: 'benefits',
		children: [
			{
				element: <PermissionGuard permission={PERMISSIONS.PROMOTION_READ} />,
				children: [
					{
						lazy: async () => {
							const { default: Component } = await import('@/features/benefits/pages/BenefitsPage');
							return { Component };
						},
						children: [
							{
								index: true,
								loader: () => redirect('promotions'),
							},
							{
								path: 'promotions',
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/benefits/promotions/pages/PromotionsPage'
									);
									return { Component };
								},
								children: [
									{
										index: true,
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/benefits/promotions/pages/PromotionsIndexPage'
											);
											return { Component };
										},
									},
									{
										element: <PermissionGuard permission={PERMISSIONS.PROMOTION_CREATE} />,
										children: [
											{
												path: 'create',
												lazy: async () => {
													const { default: Component } = await import(
														'@/features/benefits/promotions/pages/PromotionCreatePage'
													);
													return { Component };
												},
											},
										],
									},
									{
										path: ':promotionId',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/benefits/promotions/pages/PromotionsDetailsPage'
											);
											return { Component };
										},
										children: [
											{
												index: true,
												loader: () => redirect('information'),
											},
											{
												path: 'information',
												lazy: async () => {
													const { default: Component } = await import(
														'@/features/benefits/promotions/pages/PromotionInformationPage'
													);
													return { Component };
												},
											},
											{
												path: 'activity',
												lazy: async () => {
													const { default: Component } = await import(
														'@/features/benefits/promotions/pages/PromotionActivityPage'
													);
													return { Component };
												},
												children: [
													{
														index: true,
														lazy: async () => {
															const { default: Component } = await import(
																'@/features/benefits/promotions/pages/PromotionActivityIndexPage'
															);
															return { Component };
														},
													},
												],
											},
											{
												path: 'users',
												lazy: async () => {
													const { default: Component } = await import(
														'@/features/benefits/promotions/pages/PromotionTargetPage'
													);
													return { Component };
												},
												children: [
													{
														index: true,
														lazy: async () => {
															const { default: Component } = await import(
																'@/features/benefits/target/pages/TargetIndexPage'
															);
															return { Component };
														},
													},
												],
											},
										],
									},
									{
										path: ':promotionId/activity/:activityId',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/benefits/promotions/pages/PromotionActivityDetailsPage'
											);
											return { Component };
										},
									},
								],
							},

							{
								path: 'packs',
								lazy: async () => {
									const { default: Component } = await import(
										'@/features/benefits/packs/pages/PacksPage'
									);
									return { Component };
								},
								children: [
									{
										index: true,
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/benefits/packs/pages/PacksIndexPage'
											);
											return { Component };
										},
									},
									{
										// Same gate as promotions — a pack is a promotion with a different type.
										element: <PermissionGuard permission={PERMISSIONS.PROMOTION_CREATE} />,
										children: [
											{
												path: 'create',
												lazy: async () => {
													const { default: Component } = await import(
														'@/features/benefits/packs/pages/PackCreatePage'
													);
													return { Component };
												},
											},
										],
									},
									{
										path: ':packId',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/benefits/packs/pages/PacksDetailsPage'
											);
											return { Component };
										},
										children: [
											{
												index: true,
												loader: () => redirect('information'),
											},
											{
												path: 'information',
												lazy: async () => {
													const { default: Component } = await import(
														'@/features/benefits/packs/pages/PackInformationPage'
													);
													return { Component };
												},
											},
											{
												path: 'activity',
												lazy: async () => {
													const { default: Component } = await import(
														'@/features/benefits/packs/pages/PacksActivityPage'
													);
													return { Component };
												},
												children: [
													{
														index: true,
														lazy: async () => {
															const { default: Component } = await import(
																'@/features/benefits/packs/pages/PackActivityIndexPage'
															);
															return { Component };
														},
													},
												],
											},
											{
												path: 'users',
												lazy: async () => {
													const { default: Component } = await import(
														'@/features/benefits/packs/pages/PackTargetPage'
													);
													return { Component };
												},
												children: [
													{
														index: true,
														lazy: async () => {
															const { default: Component } = await import(
																'@/features/benefits/target/pages/TargetIndexPage'
															);
															return { Component };
														},
													},
												],
											},
										],
									},
									{
										path: ':packId/activity/:activityId',
										lazy: async () => {
											const { default: Component } = await import(
												'@/features/benefits/packs/pages/PackActivityDetailsPage'
											);
											return { Component };
										},
									},
								],
							},
						],
					},
				],
			},
		],
	},
];
